<nav class="navbar navbar-dark bg-primary">

    <div class="container">

        <a class="navbar-brand d-flex align-items-center" [routerLink]="[ data.URL_HOME ] | localize">
            <img class="logo" src="./assets/imagens/logo_branca.png">
        </a>

        <div id="navbarNav" class="d-flex justify-content-end">

            <ul>

                <li class="drop-down">
                    <a><i class="flag-icon {{ idiomaSelecionado.FLAG }} mr-2"></i>
                        {{ idiomaSelecionado.TITULO }}
                        <i class="fas fa-angle-down ml-2"></i></a>
                    <ul>
                        <li *ngFor="let idioma of idiomas">
                            <a (click)="alterarIdioma(idioma.CODIGO)"><i class="flag-icon {{ idioma.FLAG }} mr-2"></i>{{
                                idioma.TITULO }}</a>
                        </li>
                    </ul>
                </li>

            </ul>

        </div>

    </div>

</nav>

<div class="container-fluid bg-info">

    <div class="container">

        <div class="row d-flex align-items-center pt-3 pb-3">
            <div class="col-lg-8 d-flex justify-content-center justify-content-lg-start mt-2 mb-2">
                <h4 class="m-0 text-center text-white">{{ data.TITLE }}</h4>
            </div>

            <div class="col-lg-4 d-flex justify-content-center justify-content-lg-end mt-2 mb-2">
                <button class="btn mr-4" [ngClass]="{'btn-success': pagina == 1, 'btn-light': pagina != 1}">1</button>
                <button class="btn mr-4" [ngClass]="{'btn-success': pagina == 2, 'btn-light': pagina != 2}">2</button>
                <button class="btn" [ngClass]="{'btn-success': pagina == 3, 'btn-light': pagina != 3}">3</button>
            </div>
        </div>

    </div>

</div>